import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=52b02ec2&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./Menu.css?vue&type=style&index=0&id=52b02ec2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b02ec2",
  null
  
)

export default component.exports